// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"043464c6","453":"c2749445"}[chunkId] + ".chunk.js";
};